import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import FlaggedAdList from 'components/FlaggedAd/List';

const ScreenFlaggedAdList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <FlaggedAdList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenFlaggedAdList;
